<template>
  <background-section
    image="sections/testimonials.jpg"
    class="WinnerSection px-4 py-12 text-white pb-l border-dark-red border-t-4"
  >
    <div class="container">
      <fancy-heading
        class="text-center justify-center mb-10"
        title="МПС Експерт"
        subtitle="в този тур е:"
        horizontal
        mode="light"
      />
      <div class="flex flex-col items-center">
        <round-avatar
          :src="winner.avatar.full"
          size="xl"
        />
        <div class="text-5xl mt-6 mb-4 text-center">{{ winner.name }}</div>
        <div class="text-2xl opacity-50 mb-10">#{{ winner.ticket_number }}</div>
        <div class="w-full row justify-between font-segmented text-3xl">
          <div class="column text-center xsm:mb-6">
            <div class="font-light font-sans">Предположение</div>
            <div class="text-5xl">{{ winner.mileage }}</div>
          </div>
          <div class="column text-center">
            <div class="font-light font-sans">Разлика</div>
            <div class="text-5xl text-red">
              {{ winner.mileage | difference(mileage) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </background-section>
</template>

<script>
/**
 * @module WinnerSection
 */
export default {
  name: 'WinnerSection',
  props: {
    winner: {
      type: Object,
      required: true
    },
    mileage: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
